import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/main-layout.js";
import Philosophy from '../images/philosophy.jpeg';
import colors from '@undertheground/color';
import { Button } from '@undertheground/react';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <style>
    {`
    div{
  text-align: justify;
    }
.link {
    text-decoration: none;
    color: ${colors.pink[3]}
    }
.link:hover {
    color: ${colors.pink[6]}
}    
@media (max-width:790px){
    .image-responsive {
        display: none
    }
    .main-container {
        margin-left: 0.5rem !important;
        margin-right: 0.5rem !important;
        padding-top: 5rem
    }
}
    `}
    </style>
    <img className={'image-responsive'} style={{
      width: '100%'
    }} src={Philosophy} />
    <div className={'main-container'} style={{
      marginLeft: '12rem',
      marginRight: "6rem"
    }}>
      <h1>{`Philosophy`}</h1>
      <p>{`The `}<b>{`Under the Ground Design System`}</b>{` developed by `}<a className={'link'} href="https://wishwork.org" target="_blank">{`Wish Work`}</a>{` Team contains an open-source library for products and digital experience.
Consistency and Integrity are the key elements of the purpose for this development.
Under the Ground, at its core, consists of working codes, best practices, design resources, human-centered guidelines, and vibrant community of best software
engineers and designers.`}</p>
      <h2>{`Design Language`}</h2>
      <p>{`Our design system came to exist as our team would try to deliver state-of-the-art products for complex systems. It helps us develop a common language for designers, developers, and stakeholders.
Establishing a design language allows everyone to speak the same design language without the need for translation.`}</p>
      <h2>{`Fundamentals`}</h2>
      <p>{`Our principles provide clear criteria for the concepts, craftsmanship and creativity our brand demands and which our team, our stackeholders and our clients deserve.
However, just being creative and not paying meticulous attention to the brand identity and company's intellectual roots couldn't lead to a `}<b style={{
          color: colors.blue[3]
        }}>{`Mesmerizing Design`}</b>{`.
For this reason, we consider describing the main attributes of the Under the Ground design system which form its foundation.`}</p>
      <div style={{
        padding: '0 1rem'
      }}>
        <h3><p style={{
            color: colors.blue[3]
          }}>{`Simplicity`}</p></h3>
        <p>{`Our vision as a software company is to develop high quality products with any complexity. There is a quote by Chopin stated that
"Simplicity is the final achievement. After one has played a vast quantity of notes and more notes, it is simplicity that emerges as the crowning reward of art".
Therefore, Simplicity is one of the key attributes of this design system. In this regard, any element should decrease the complication rather than increase. `}</p>
        <h3><p style={{
            color: colors.blue[3]
          }}>{`Engineered `}</p></h3>
        <p>{`From atoms to complex elements of the Under the Ground design system has been engineered by the best software engineers and designers. We think in user experience in a engineering way, rather than intuitive.
Most compelling ideas at the first are so uncanny that if you want to count on your intuition, you make a lot of mistakes. we think in user experience in a engineered way, collecting data for having the best
possible user experience and interface. `}</p>
        <h3><p style={{
            color: colors.blue[3]
          }}>{`Integrity without Similarity`}</p></h3>
        <p>{`We develop many products for many reasons. we need to have a signiture for ourselves so that any one could easily comprehend that these products has been developed by Wish Work team.
On the other hand, as our purpose of these developments maybe diverse, our products doesn't have complete similarity with each other.`}</p>
        <h3><p style={{
            color: colors.blue[3]
          }}>{`Inspired`}</p></h3>
        <p>{`As a software company, respect people who inspired us in the path of deliver any value within our design form. We don't hesitate to admire the people who make
the software world available to show aesthetic in the virtual world. `}</p>
      </div>
    </div>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      